import { useProjectStore } from 'gpcore-apikit/store/pinia/project';
import { useSessionStore } from 'gpcore-apikit/store/pinia/session';
import { computed } from 'vue';

export default () => {
  const sessionStore = useSessionStore();

  const userEmailIsConfirmed = computed(() => sessionStore.user.confirmed);

  const projectStore = useProjectStore();
  const userHasCurrentProject = computed(() => projectStore.current !== null);
  const userHasProjects = computed(
    () => projectStore.projects.length > 0 && userHasCurrentProject.value,
  );

  const nodeLimit = computed(() => projectStore.projectNodeLimit);
  const userIsallowedToCreateNodes = computed(() => nodeLimit.value > 0);

  return {
    userEmailIsConfirmed,
    userHasProjects,
    userIsallowedToCreateNodes,
  };
};
